<div class="modal-header">
    <h5 class="modal-title">{{user.userId ? 'Edit' : 'New'}} User</h5>
    <button type="button" class="btn-close" (click)="dismiss()" aria-label="Close"></button>
</div>
<dirty-tracking [forms]="[userForm]"></dirty-tracking>
<form novalidate #userForm="ngForm" [ngClass]="{'was-validated': submitAttempt}">
    <div class="modal-body">
        <h5 class="text-primary text-strong mb-3">User Profile</h5>
        <div class="row gx-3">
            <div class="col-md mb-3">
                <label for="userFirstName" class="form-label">First Name<sup class="text-danger">*</sup></label>
                <input type="text" focus-me class="form-control form-control-lg" id="userFirstName" name="userFirstName" placeholder="First Name" required [(ngModel)]="user.firstName">
                <div class="invalid-feedback">
                    <i class="fas fa-exclamation-circle"></i> This field is required.
                </div>
            </div>
            <div class="col-md mb-3">
                <label for="userLastName" class="form-label">Last Name<sup class="text-danger">*</sup></label>
                <input type="text" class="form-control form-control-lg" id="userLastName" name="userLastName" placeholder="Last Name" required [(ngModel)]="user.lastName">
                <div class="invalid-feedback">
                    <i class="fas fa-exclamation-circle"></i> This field is required.
                </div>
            </div>
        </div>
        <div class="row gx-3">
            <div class="col-md mb-3">
                <label for="userEmail" class="form-label">Email Address<sup class="text-danger">*</sup></label>
                <input type="email" class="form-control form-control-lg" id="userEmail" name="userEmail" placeholder="Email Address" required [(ngModel)]="user.emailAddress">
                <div class="invalid-feedback">
                    <i class="fas fa-exclamation-circle"></i> This field is required.
                </div>
            </div>
        </div>
        <div class="row gx-3">
            <div class="col-md mb-3">
                <label for="userTitle" class="form-label">Title</label>
                <input type="text" class="form-control form-control-lg" id="userTitle" name="userTitle" placeholder="Title" [(ngModel)]="user.title">
            </div>
            <div class="col-md mb-3">
                <label for="userPhone" class="form-label">Phone</label>
                <input type="phone" class="form-control form-control-lg" id="userPhone" name="userPhone" placeholder="Phone" [(ngModel)]="user.phoneNumber">
            </div>
        </div>
        <div class="row gx-3">
            <div class="col-md">
                <label for="userStatus" class="form-label">Status</label>
                <div class="form-check checkbox-slider--b-flat checkbox-slider-md">
                    <label class="m-0">
                        <input type="checkbox" id="editUserStatus" name="userEditStatus" [(ngModel)]="user.isActive"><span class="user-toggle" [ngClass]="user.isActive ? 'text-success' : 'text-danger'">{{user.isActive ? 'Active' : 'Deactivated'}}</span>
                    </label>
                </div>
            </div>
            <div class="col-md" *ngIf="!user.userId">
                <label for="userStatus" class="form-label">Is PDx Admin</label>
                <div class="form-check checkbox-slider--b-flat checkbox-slider-md">
                    <label class="m-0">
                        <input type="checkbox" id="isPDxAdmin" name="isPDxAdmin" [(ngModel)]="user.isPDxAdmin"><span class="user-toggle">{{user.isPDxAdmin ? 'Yes' : 'No'}}</span>
                    </label>
                </div>
            </div>
        </div>
        <!-- Hiding for now, this is all account/entity related...
        <hr />
        <h5 class="text-primary text-strong mb-3">Account</h5>
        <div class="row gx-3 align-items-end mb-4">
            <div class="col-md mobiscroll-select">
                <label>
                    <input mbsc-input id="permissions-input" data-dropdown="true" data-tags="true" placeholder="Select customer permissions…" />
                </label>
                <select id="permissions-select" multiple>
                    <option>Approver</option>
                    <option>Receiver</option>
                    <option>Payables</option>
                    <option>GL Codes</option>
                </select>
            </div>
        </div>
        <div class="row gx-3">
            <div class="col-md mobiscroll-select">
                <label for="userAccount" class="form-label">Account<sup class="text-danger">*</sup></label>
                <input class="form-control form-control-lg mobi-input" id="set-account-input" data-dropdown="true" placeholder="Account" required />
                <select id="set-account-select">
                    <option value="atl">Dawes & Fretzin Dermatology</option>
                    <option value="ber">Eye Surgery Center of New York</option>
                    <option value="bos">Fromer Eye Centers</option>
                    <option value="chi">Indiana Skin Cancer Center</option>
                </select>
                <div class="invalid-feedback">
                    <i class="fas fa-exclamation-circle"></i> This field is required.
                </div>
            </div>
        </div>
    -->
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-outline-black btn-round btn-lg" (click)="dismiss()"><i class="far fa-times"></i> Cancel</button>
        <button type="submit" class="btn btn-secondary btn-round btn-lg" (click)="save(userForm)"><i class="far fa-check"></i> Save</button>
    </div>
</form>